module.exports = __webpack_public_path__ + "static/media/extension1.95b72708.png";